import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
} from '@tanstack/react-router';
import {
  Cake,
  CalendarDays,
  CircleArrowLeft,
  GraduationCap,
} from 'lucide-react';

import {
  getClassQueryOptions,
  useGetClass,
} from '~entities/classes/api/get-class';
import { redirectIfClassMissing } from '~entities/classes/lib/redirect-if-class-missing';

import { TabList, type TabListItem } from '~shared/components/tab-list';

function getTabsList(classId: string, pathname: string): Array<TabListItem> {
  return [
    {
      href: `/classes/${classId}/all`,
      label: 'All',
      active: pathname.includes(`${classId}/all`),
      icon: CalendarDays,
    },
    {
      href: `/classes/${classId}/present`,
      label: 'All Present',
      active: pathname.includes(`${classId}/present`),
      icon: Cake,
    },
    {
      href: `/classes/${classId}/absent`,
      label: 'All Absent',
      active: pathname.includes(`${classId}/absent`),
      icon: GraduationCap,
    },
  ] as const;
}
const Component = () => {
  const { pathname } = useLocation();
  const { classId } = Route.useParams();

  const tabsList = getTabsList(classId, pathname);

  const { data } = useGetClass({ classId });

  const isUpdateRoute = pathname.includes(`/update`);
  const isEnrolledStudentsRoute = pathname.includes(`/enrolled-students`);
  const isTrialRoute = pathname.includes(`/trial`);
  const isBulkEnrollStudentsRoute = pathname.includes(`/bulk-enroll-students`);
  const isWaitListRoute = pathname.includes(`/wait-list`);

  return (
    <div className=''>
      {!isUpdateRoute &&
        !isEnrolledStudentsRoute &&
        !isTrialRoute &&
        !isBulkEnrollStudentsRoute &&
        !isWaitListRoute && (
          <>
            <div className='flex min-w-0 items-center justify-between'>
              <Link to='/classes' className='flex min-w-0 items-center gap-2'>
                <CircleArrowLeft className='size-6 shrink-0 text-custom-secondary-1' />
                <h2 className='truncate text-xl font-semibold text-custom-secondary-1 sm:text-2xl'>
                  {data?.title}
                </h2>
              </Link>
            </div>
            <div className='mt-4'>{<TabList tabList={tabsList} />}</div>
            <div className='border-t'>
              <Outlet />
            </div>
          </>
        )}

      {(isUpdateRoute ||
        isEnrolledStudentsRoute ||
        isTrialRoute ||
        isBulkEnrollStudentsRoute ||
        isWaitListRoute) && <Outlet />}
    </div>
  );
};

export const Route = createFileRoute('/_auth/_layout/classes/$classId')({
  loader: async ({ params, context }) => {
    try {
      return await context.queryClient.ensureQueryData(
        getClassQueryOptions(params.classId),
      );
    } catch (error) {
      redirectIfClassMissing(error);
      throw error;
    }
  },
  component: Component,
});
